module.exports = __webpack_public_path__ + "img/mobileproductBanner.e8a1ffbf.png";